class NullAccountSwitcherLoader {
  serialize() {
    return {};
  }

  get activeAccount() {
    return {
      serialize: () => ({ id: null })
    };
  }

  get activePublication() {
    return {
      serialize: () => ({ id: null })
    };
  }

  get publications() {
    return [{ id: null }];
  }
}

export default NullAccountSwitcherLoader;



// WEBPACK FOOTER //
// ./app/javascript/app/components/nav/null_account_switcher_loader.js